class FacetFilter extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.listId = this.getAttribute('data-list-id');
    this.list = document.getElementById(this.listId);

    if (!this.input || !this.list) {
      return;
    }

    this.input.addEventListener('input', () => this.filterItems());
  }

  filterItems() {
    if (!this.list) {
      return;
    }

    const query = this.input.value.toLowerCase();
    const items = this.list.querySelectorAll('li');

    items.forEach((item, index) => {
      const label = item.getAttribute('data-label')?.toLowerCase() || item.innerText.toLowerCase();
      const matches = query === '' || label.includes(query);

      if (matches) {
        item.classList.remove('facet-hidden');
        item.classList.toggle('hidden', query === '' && index > 5);
        return;
      }

      item.classList.add('facet-hidden');
    });

    const showMoreButton = this.list.parentElement.parentElement.querySelector('button.button-show-more');

    if (!showMoreButton) {
      return;
    }

    if (query !== '') {
      showMoreButton.classList.add('search-hidden');
      return;
    }

    showMoreButton.classList.remove('search-hidden');
  }
}

customElements.define('facet-filter', FacetFilter);
